
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function AffiliateTerms() {
  return (
    <div className="container max-w-4xl py-8">
      <Card>
        <CardHeader>
          <div className="flex items-center gap-2 mb-2">
            <Button variant="ghost" size="icon" asChild className="h-8 w-8">
              <Link to="/affiliate/dashboard">
                <ArrowLeft className="h-4 w-4" />
              </Link>
            </Button>
            <CardTitle>Affiliate Program Terms & Conditions</CardTitle>
          </div>
          <CardDescription>
            Read our affiliate program terms carefully before applying
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-3">Commission Structure</h2>
            <div className="border rounded-md overflow-hidden">
              <table className="w-full">
                <thead className="bg-muted">
                  <tr>
                    <th className="px-4 py-3 text-left font-medium">Plan Type</th>
                    <th className="px-4 py-3 text-right font-medium">Commission Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t">
                    <td className="px-4 py-3">Basic Monthly</td>
                    <td className="px-4 py-3 text-right font-medium">₹15</td>
                  </tr>
                  <tr className="border-t">
                    <td className="px-4 py-3">Basic Annual</td>
                    <td className="px-4 py-3 text-right font-medium">₹80</td>
                  </tr>
                  <tr className="border-t">
                    <td className="px-4 py-3">Pro Monthly</td>
                    <td className="px-4 py-3 text-right font-medium">₹50</td>
                  </tr>
                  <tr className="border-t">
                    <td className="px-4 py-3">Pro Annual</td>
                    <td className="px-4 py-3 text-right font-medium">₹200</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-sm text-muted-foreground mt-2">
              Commission rates are subject to change with 30-day notice to active affiliates
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Payment Terms</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Weekly payouts for all approved commissions</li>
              <li>Minimum payout amount: ₹100</li>
              <li>Payment methods: UPI, Paytm, Bank Transfer</li>
              <li>Commissions are paid only after the customer's refund period expires (14 days)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Tracking & Attribution</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>30-day cookie tracking window</li>
              <li>Last-click attribution model</li>
              <li>Commissions are not paid for self-referrals or fraudulent transactions</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Promotional Guidelines</h2>
            <p className="mb-4">As an affiliate, you agree to follow these promotional guidelines:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>No spamming or unsolicited emails to promote Edaptica</li>
              <li>No false or misleading claims about Edaptica products or services</li>
              <li>No bidding on branded keywords in paid search campaigns</li>
              <li>Only promote Edaptica on platforms that comply with all applicable laws</li>
              <li>You must disclose your affiliate relationship in accordance with local laws</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Program Eligibility & Termination</h2>
            <p className="mb-4">Edaptica reserves the right to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Approve or reject any affiliate application at our sole discretion</li>
              <li>Terminate affiliate relationships with 7 days' notice</li>
              <li>Immediate termination for violations of these terms</li>
              <li>Withhold payment for suspected fraudulent activity</li>
            </ul>
          </section>

          <div className="flex justify-center">
            <Button asChild>
              <Link to="/affiliate/apply">Apply to Become an Affiliate</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
